import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46c6c70d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "login",
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "Connect")
], -1))
const _hoisted_3 = { class: "section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please enter your email to continue.", -1))
const _hoisted_5 = {
  class: "section",
  style: {"padding-top":"12px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  class: "section error",
  style: {"min-height":"18px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "small" }, " Forgot your email? Contact SocietyOne or visit our website to retrieve it. ")
], -1))
const _hoisted_10 = {
  class: "section button-bar",
  style: {"text-align":"center"}
}
const _hoisted_11 = {
  key: 1,
  id: "otp",
  class: "content"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "heading" }, "One Time Password")
], -1))
const _hoisted_13 = { class: "section" }
const _hoisted_14 = {
  class: "section",
  style: {"padding-top":"12px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "oneTimePassword" }, "One Time Password", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "section success"
}
const _hoisted_18 = {
  key: 1,
  class: "section error"
}
const _hoisted_19 = { class: "section" }
const _hoisted_20 = { class: "small" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Didn't get the code? ")
const _hoisted_22 = {
  class: "section button-bar",
  style: {"text-align":"center"}
}
const _hoisted_23 = { class: "info-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.step === 'login' && _ctx.applicationStore.dataRecipient != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, " You have requested to share your CDR data with " + _toDisplayString(_ctx.applicationStore.dataRecipient.clientName) + ". ", 1),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _hoisted_6,
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                name: "email",
                type: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
              }, null, 512), [
                [_vModelText, _ctx.username]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.error), 1),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              name: "submit",
              class: "medium so-primary-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.initOTP())),
              style: {"min-width":"120px"}
            }, " Continue "),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                name: "cancel",
                class: "medium so-secondary-1",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
              }, " Cancel ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 'OTP')
      ? (_openBlock(), _createElementBlock("main", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", null, " You have requested to share your CDR data with " + _toDisplayString(_ctx.applicationStore.dataRecipient.clientName) + ". ", 1),
            _createElementVNode("p", null, " Enter the code sent to your mobile phone registered with " + _toDisplayString(_ctx.DH.name) + ". ", 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              id: "oneTimePassword",
              name: "oneTimePassword",
              type: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.otp) = $event)),
              title: "One time password"
            }, null, 512), [
              [_vModelText, _ctx.otp]
            ])
          ]),
          (_ctx.info)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.info), 1))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("a", {
                class: "add-height",
                href: "#",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.initOTP())),
                title: "Resend OTP code"
              }, "Resend code"),
              _createTextVNode(" or contact " + _toDisplayString(_ctx.DH.name) + " to update your details. ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              title: "Continue",
              name: "submit",
              class: "medium so-primary-1",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirect())),
              style: {"min-width":"120px"}
            }, " Continue "),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                name: "cancel",
                class: "medium so-secondary-1",
                title: "Cancel",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancel()))
              }, " Cancel ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.applicationStore.dataRecipient)
        ? (_openBlock(), _createBlock(_component_Footer, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}